import React, { useState, useMemo } from "react";

const artigos = [
  {
    titulo: "Modelagem matemática: como os significados e conceitos matemáticos são apreendidos pelos deficientes auditivos",
    autor: "Rita de Cássia Barbosa Arouca",
    ano: "2004",
    tipo: "VII Encontro Nacional de Educação Matemática",
    categoria: "nacional"
  },
  {
    titulo: "Possibilidade de ensino que incorpore Modelagem Matemática em escolas para surdos",
    autor: "Yoshinori Nakamura, Nobuaki Kuroki",
    ano: "2004",
    tipo: "Coleção de artigos da reunião anual da Sociedade Japonesa para Educação Científica",
    categoria: "internacional"
  },
  {
    titulo: "Modelagem Matemática na educação matemática com estudantes surdos: resultados iniciais de um estudo",
    autor: "Márcia Cristina Ribas; Marcio André Martins",
    ano: "2018a",
    tipo: "VIII Encontro Paranaense de Modelagem na Educação Matemática",
    categoria: "nacional"
  },
];

export default function TabelaArtigos() {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortField, setSortField] = useState("");
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);

  // Filtrar e ordenar artigos
  const filteredAndSortedArtigos = useMemo(() => {
    let filtered = artigos.filter(artigo =>
      artigo.titulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      artigo.autor.toLowerCase().includes(searchTerm.toLowerCase()) ||
      artigo.tipo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      artigo.ano.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (sortField === 'ano') {
      filtered.sort((a, b) => b.ano.localeCompare(a.ano));
    } else if (sortField === 'autor') {
      filtered.sort((a, b) => a.autor.localeCompare(b.autor));
    }

    return filtered;
  }, [searchTerm, sortField]);

  const handleViewDetails = (artigo) => {
    setSelectedArticle(artigo);
    setIsModalOpen(true);
  };

  const handleExportArticle = (artigo) => {
    const data = `Título: ${artigo.titulo}\nAutor: ${artigo.autor}\nAno: ${artigo.ano}\nTipo: ${artigo.tipo}`;
    const blob = new Blob([data], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `pesquisa_${artigo.ano}_${artigo.autor.split(' ')[0]}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedArticle(null);
  };

  const styles = {
    container: {
      background: 'linear-gradient(135deg, #f8fafc 0%, #e0f2fe 50%, #e8eaf6 100%)',
      minHeight: '100vh',
      padding: '2rem 1rem',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif'
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem'
    },
    iconContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '64px',
      height: '64px',
      background: 'linear-gradient(45deg, #2563eb, #4f46e5)',
      borderRadius: '50%',
      marginBottom: '1rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '0.5rem',
      margin: '0 0 0.5rem 0'
    },
    subtitle: {
      fontSize: '1.125rem',
      color: '#6b7280',
      maxWidth: '42rem',
      margin: '0 auto',
      lineHeight: '1.6'
    },
    searchContainer: {
      background: 'white',
      borderRadius: '1rem',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
      padding: '1.5rem',
      marginBottom: '2rem',
      maxWidth: '1200px',
      margin: '0 auto 2rem auto'
    },
    searchWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      alignItems: 'center'
    },
    inputContainer: {
      position: 'relative',
      flex: '1',
      width: '100%',
      maxWidth: '600px'
    },
    searchIcon: {
      position: 'absolute',
      left: '1rem',
      top: '50%',
      transform: 'translateY(-50%)',
      color: '#9ca3af',
      zIndex: 1
    },
    input: {
      width: '100%',
      paddingLeft: '3rem',
      paddingRight: '1rem',
      paddingTop: '0.75rem',
      paddingBottom: '0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '0.75rem',
      outline: 'none',
      transition: 'all 0.3s ease',
      fontSize: '1rem',
      boxSizing: 'border-box'
    },
    buttonContainer: {
      display: 'flex',
      gap: '0.5rem',
      flexWrap: 'wrap'
    },
    button: (isActive) => ({
      padding: '0.75rem 1rem',
      borderRadius: '0.75rem',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      transition: 'all 0.2s ease',
      background: isActive ? '#dbeafe' : '#eff6ff',
      color: isActive ? '#1e40af' : '#3730a3',
      fontSize: '0.875rem',
      fontWeight: '500'
    }),
    tableContainer: {
      background: 'white',
      borderRadius: '1rem',
      boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      overflow: 'hidden',
      maxWidth: '1200px',
      margin: '0 auto'
    },
    tableHeader: {
      background: 'linear-gradient(90deg, #2563eb 0%, #3b82f6 50%, #4f46e5 100%)',
      color: 'white',
      padding: '1.5rem'
    },
    headerContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '1rem'
    },
    headerTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '0.25rem',
      margin: '0 0 0.25rem 0'
    },
    headerSubtitle: {
      color: '#bfdbfe',
      fontSize: '0.875rem',
      margin: 0
    },
    countContainer: {
      textAlign: 'right'
    },
    count: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
      margin: 0
    },
    countLabel: {
      color: '#bfdbfe',
      fontSize: '0.875rem',
      margin: 0
    },
    tableWrapper: {
      overflowX: 'auto'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    thead: {
      background: 'linear-gradient(90deg, #f9fafb 0%, #eff6ff 100%)'
    },
    th: {
      padding: '1rem 1.5rem',
      textAlign: 'left',
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#374151',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    thContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    row: (isHovered) => ({
      borderBottom: '1px solid #f3f4f6',
      transition: 'all 0.3s ease',
      background: isHovered ? '#eff6ff' : 'white',
      transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
      boxShadow: isHovered ? '0 8px 25px rgba(59, 130, 246, 0.15)' : 'none'
    }),
    td: {
      padding: '1.25rem 1.5rem',
      verticalAlign: 'top'
    },
    titleCell: {
      fontWeight: '500',
      color: '#111827',
      lineHeight: '1.5'
    },
    authorName: {
      color: '#1f2937',
      fontWeight: '500',
      marginBottom: '0.25rem'
    },
    yearInfo: {
      fontSize: '0.875rem',
      color: '#6b7280',
      display: 'flex',
      alignItems: 'center',
      gap: '0.25rem'
    },
    categoryBadge: (categoria) => ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem',
      padding: '0.5rem 0.75rem',
      borderRadius: '9999px',
      fontSize: '0.75rem',
      fontWeight: '500',
      background: categoria === 'internacional' ? '#f3e8ff' : '#dbeafe',
      color: categoria === 'internacional' ? '#7c3aed' : '#2563eb',
      whiteSpace: 'nowrap'
    }),
    actionContainer: {
      display: 'flex',
      gap: '0.5rem'
    },
    actionButton: (color) => ({
      padding: '0.5rem',
      border: 'none',
      borderRadius: '0.5rem',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      background: 'transparent',
      color: color,
      fontSize: '1rem'
    }),
    footer: {
      background: 'linear-gradient(90deg, #f9fafb 0%, #eff6ff 100%)',
      padding: '1rem 1.5rem',
      borderTop: '1px solid #e5e7eb'
    },
    footerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '1rem',
      fontSize: '0.875rem'
    },
    footerLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      color: '#4b5563',
      flexWrap: 'wrap'
    },
    footerItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    footerRight: {
      fontSize: '0.875rem',
      color: '#6b7280'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '1rem'
    },
    modal: {
      background: 'white',
      borderRadius: '1rem',
      maxWidth: '42rem',
      width: '100%',
      maxHeight: '90vh',
      overflowY: 'auto',
      padding: '1.5rem'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '1rem'
    },
    modalTitle: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0
    },
    closeButton: {
      background: 'none',
      border: 'none',
      color: '#9ca3af',
      fontSize: '1.5rem',
      cursor: 'pointer',
      padding: '0.25rem'
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    modalSection: {
      marginBottom: '1rem'
    },
    modalSectionTitle: {
      fontWeight: '600',
      color: '#374151',
      marginBottom: '0.5rem',
      margin: '0 0 0.5rem 0'
    },
    modalText: {
      color: '#1f2937',
      lineHeight: '1.6',
      margin: 0
    },
    modalGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '1rem'
    }
  };

  return (
    <div style={styles.container}>
      <br></br>
      <br></br>
      <div style={styles.header}>
        <div style={styles.iconContainer}>
          <i className="fas fa-graduation-cap" style={{color: 'white', fontSize: '1.5rem'}}></i>
        </div>
        <h1 style={styles.title}>Pesquisas Acadêmicas</h1>
        <p style={styles.subtitle}>
          Modelagem Matemática e Deficiência Auditiva - Compilação de estudos sobre educação matemática inclusiva
        </p>
      </div>
      <br></br>


      <div style={styles.tableContainer}>
        <div style={styles.tableHeader}>
          <div style={styles.headerContent}>
            <div>
              <h2 style={styles.headerTitle}>Biblioteca de Pesquisas</h2>
              <p style={styles.headerSubtitle}>Estudos sobre educação matemática inclusiva</p>
            </div>
            <div style={styles.countContainer}>
              <div style={styles.count}>{filteredAndSortedArtigos.length}</div>
              <div style={styles.countLabel}>Pesquisas</div>
            </div>
          </div>
        </div>

        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead style={styles.thead}>
              <tr>
                <th style={styles.th}>
                  <div style={styles.thContent}>
                    <i className="fas fa-book" style={{color: '#3b82f6'}}></i>
                    Título da Pesquisa
                  </div>
                </th>
                <th style={styles.th}>
                  <div style={styles.thContent}>
                    <i className="fas fa-user-graduate" style={{color: '#6366f1'}}></i>
                    Autor & Ano
                  </div>
                </th>
                <th style={styles.th}>
                  <div style={styles.thContent}>
                    <i className="fas fa-file-alt" style={{color: '#10b981'}}></i>
                    Tipo de Publicação
                  </div>
                </th>
                <th style={styles.th}>
                  <div style={styles.thContent}>
                    <i className="fas fa-cog" style={{color: '#6b7280'}}></i>
                    Ações
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredAndSortedArtigos.map((artigo, index) => (
                <tr 
                  key={index}
                  style={styles.row(hoveredRow === index)}
                  onMouseEnter={() => setHoveredRow(index)}
                  onMouseLeave={() => setHoveredRow(null)}
                >
                  <td style={styles.td}>
                    <div style={styles.titleCell}>
                      {artigo.titulo}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <div style={styles.authorName}>{artigo.autor}</div>
                    <div style={styles.yearInfo}>
                      <i className="fas fa-calendar-alt"></i>
                      {artigo.ano}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <span style={styles.categoryBadge(artigo.categoria)}>
                      <i className={artigo.categoria === 'internacional' ? 'fas fa-globe' : 'fas fa-flag'}></i>
                      {artigo.tipo}
                    </span>
                  </td>
                  <td style={styles.td}>
                    <div style={styles.actionContainer}>
                      <button 
                        onClick={() => handleViewDetails(artigo)}
                        style={styles.actionButton('#2563eb')}
                        onMouseEnter={(e) => e.target.style.background = '#dbeafe'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                        title="Ver detalhes"
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <button 
                        onClick={() => handleExportArticle(artigo)}
                        style={styles.actionButton('#059669')}
                        onMouseEnter={(e) => e.target.style.background = '#d1fae5'}
                        onMouseLeave={(e) => e.target.style.background = 'transparent'}
                        title="Exportar"
                      >
                        <i className="fas fa-download"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={styles.footer}>
          <div style={styles.footerContent}>
            <div style={styles.footerLeft}>
              <span style={styles.footerItem}>
                <i className="fas fa-calendar" style={{color: '#3b82f6'}}></i>
                Período: 2004 - 2018
              </span>
              <span style={styles.footerItem}>
                <i className="fas fa-globe" style={{color: '#10b981'}}></i>
                Pesquisas Internacionais
              </span>
            </div>
            <div style={styles.footerRight}>
              Última atualização: <span style={{fontWeight: '500'}}>Dezembro 2024</span>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && selectedArticle && (
        <div style={styles.modalOverlay} onClick={closeModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Detalhes da Pesquisa</h3>
              <button onClick={closeModal} style={styles.closeButton}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div style={styles.modalContent}>
              <div style={styles.modalSection}>
                <h4 style={styles.modalSectionTitle}>Título</h4>
                <p style={styles.modalText}>{selectedArticle.titulo}</p>
              </div>
              <div style={styles.modalSection}>
                <h4 style={styles.modalSectionTitle}>Autor(es)</h4>
                <p style={styles.modalText}>{selectedArticle.autor}</p>
              </div>
              <div style={styles.modalGrid}>
                <div style={styles.modalSection}>
                  <h4 style={styles.modalSectionTitle}>Ano</h4>
                  <p style={styles.modalText}>{selectedArticle.ano}</p>
                </div>
                <div style={styles.modalSection}>
                  <h4 style={styles.modalSectionTitle}>Categoria</h4>
                  <span style={styles.categoryBadge(selectedArticle.categoria)}>
                    <i className={selectedArticle.categoria === 'internacional' ? 'fas fa-globe' : 'fas fa-flag'}></i>
                    {selectedArticle.categoria}
                  </span>
                </div>
              </div>
              <div style={styles.modalSection}>
                <h4 style={styles.modalSectionTitle}>Tipo de Publicação</h4>
                <p style={styles.modalText}>{selectedArticle.tipo}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}